import baseApi from "../../../shared/api/baseApi";
import { ResponseDto } from "../../../shared/dto/responseDto";
import { statusFromStn, statusGroupFromStn } from "../utils/useSensor";

type SensorDatas = {
    list: SensorDataDto[];
}

type SensorDataDto = {
    imei: string;
    sensorAlias: string;
    regionId: string;
    sensorLat: number;
    sensorLot: number;
    sensorMngDept: string | null;
    sensorMngNo: string;
    sensorAddress: string;
    lastStatus: string;
    lastHumidity: number;
    lastTmpr: number;
    lastWind: number;
    sensorRemark: string | null;
    regionName: string;
    sensorInstallAt: string;
    lastDatetime: string;
    createAt: string;
    updateAt: string;
    sensorStatusGrp: string;
    isNew: string;
}

type SensorDataParams = {
    status?: string;
    searchKeyword?: string;
}


type SensorDataStn = {
    imei: string;
    "region": {
        groupCode: string;
        id: number;
        name: string;
        depth: number;
        parent: number;
        parentCode: string | null;
        comment: string;
        children: [];
        useYn: string;
        holiday: string | null;
    },
    y: number;
    x: number;
    department: string;
    manageCd: string;
    address: string;
    status: string;
    statusGroup: string;
    lastTemp: number;
    lastHumidity: number;
    lastWind: number;
    installDt: string;
    lastInsertDtm: string;
    comment: string;
    standard: number | null;
    isNew: string;
    useAutoSpray: string | null;
    lastSprayDate: string | null;
    deviceId: string | null;
}

function convertSensorDataStnToSensorDataDto(sensorDataStn: SensorDataStn): SensorDataDto {
    return {
        imei: sensorDataStn.imei,
        regionId: "regionId",
        regionName: sensorDataStn.region.name,
        sensorLat: sensorDataStn.y,
        sensorLot: sensorDataStn.x,
        sensorMngDept: null,
        sensorMngNo: sensorDataStn.manageCd,
        sensorAddress: sensorDataStn.address,
        lastStatus: sensorDataStn.status,
        sensorStatusGrp: statusGroupFromStn(sensorDataStn.statusGroup),
        lastTmpr: sensorDataStn.lastTemp,
        lastHumidity: sensorDataStn.lastHumidity,
        lastWind: sensorDataStn.lastWind,
        sensorRemark: sensorDataStn.comment,
        lastDatetime: sensorDataStn.lastInsertDtm,
        sensorInstallAt: sensorDataStn.installDt,
        createAt: "",
        updateAt: "",
        sensorAlias: sensorDataStn.manageCd,
        isNew: sensorDataStn.isNew,
    }
}

const sensorDataApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getSensorData: builder.query<SensorDataDto[], SensorDataParams | undefined>({
            query: (params?: SensorDataParams) => {
                return ({
                url: "/system/sensors",
                // params: {
                //     kStatus: params?.status === "전체" ? "" : params?.status,
                //     kSearchKeyword: params?.searchKeyword,
                // }
            })},
            transformResponse: (response: ResponseDto<SensorDataStn[]>) => {
                const results = [];
                if(response.code == "00") {
                    response.data.forEach(item => {
                        results.push(convertSensorDataStnToSensorDataDto(item));
                    });
                }
                return results;
            },
        })
    })
})

export { sensorDataApi };
export const { useGetSensorDataQuery } = sensorDataApi;
export type { SensorDataDto };